import Fetch, { NewAxiosRequestConfig } from '@/utils/axios';

/**
 * 获取导航栏标签数据
 * 判断是否给navigate加上气泡、new或红点
 * @returns
 */
export const getNavigationLabelList = (zipcode: string) => {
  return Fetch.get('/ec/content/navigate/label/list', { zipcode });
};

/**
 * 点击导航按钮调用接口
 * 导航按钮上有的徽标点击后会清除，需要调用一次接口
 */
export const clickNavigation = (navigate_config_id: number, zipcode: string): Promise<AResponse> => {
  return Fetch.post('/ec/content/navigate/label/click', { navigate_config_id, zipcode });
};

export const reportLogs = (url: string, params: any) => {
  navigator.sendBeacon(url, JSON.stringify(params));
};
